import React from 'react';
import {
  Drawer,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  Typography,
} from '@mui/material';
import { Event, UploadFile, People, School, GroupWork } from '@mui/icons-material';

interface SidebarProps {
  drawerOpen: boolean;
  onDrawerToggle: () => void;
  onMenuItemClick: (item: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ drawerOpen, onDrawerToggle, onMenuItemClick }) => {
  return (
    <Drawer
      anchor="left"
      open={drawerOpen}
      onClose={onDrawerToggle}
    >
      <Box
        sx={{ width: 250 }}
        role="presentation"
        onClick={onDrawerToggle}
      >
        <List>
          <ListItem button onClick={() => onMenuItemClick('tournaments')}>
            <ListItemIcon>
              <Event />
            </ListItemIcon>
            <ListItemText primary="Tournaments" />
          </ListItem>
          <ListItem button onClick={() => onMenuItemClick('import')}>
            <ListItemIcon>
              <UploadFile />
            </ListItemIcon>
            <ListItemText primary="Import Data" secondary="CSV/Copy-Paste" />
          </ListItem>
          <ListItem button onClick={() => onMenuItemClick('wrestlers')}>
            <ListItemIcon>
              <People />
            </ListItemIcon>
            <ListItemText primary="All Wrestlers" />
          </ListItem>
          <ListItem button onClick={() => onMenuItemClick('teams')}>
            <ListItemIcon>
              <School />
            </ListItemIcon>
            <ListItemText primary="Teams Overview" />
          </ListItem>
          <ListItem button onClick={() => onMenuItemClick('draw')}>
            <ListItemIcon>
              <GroupWork />
            </ListItemIcon>
            <ListItemText primary="Tournament Draw" />
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem button>
            <ListItemText primary="Match Results" secondary="Coming soon" />
          </ListItem>
        </List>
        <Divider />
        
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-end',
          height: '100%',
        }}
      >
          <Typography variant="caption" align="center" sx={{ mt: 2, color: 'primary.main' }}>
            Version: Alpha v0.0.2
          </Typography>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
